/* Hertz documents - variant-aware document browser.
   Renders one collapsible per category, filtered against the current
   <product-constructor> selections. No network calls. */
(function () {
  'use strict';

  var PARAMS = ['tank configuration', 'dryer', 'pressure', 'voltage'];

  var CARET = '<svg width="16" height="8" viewBox="0 0 16 8" aria-hidden="true" focusable="false" class="icon icon-caret">' +
    '<path d="M6.15152 7.26893C6.54775 7.66516 7.03314 7.86328 7.60768 7.86328C8.18221 7.86328 8.6676 7.66516 9.06383 7.26893L15.0073 1.32543C15.146 1.18675 15.2154 1.02331 15.2154 0.835096C15.2154 0.646885 15.146 0.483439 15.0073 0.344758C14.8686 0.206076 14.7052 0.136735 14.517 0.136735C14.3288 0.136735 14.1653 0.206076 14.0267 0.344758L8.08316 6.28825C7.96429 6.40712 7.80579 6.46656 7.60768 6.46656C7.40956 6.46656 7.25107 6.40712 7.1322 6.28825L1.1887 0.344758C1.05002 0.206076 0.886572 0.136735 0.698361 0.136735C0.51015 0.136735 0.346704 0.206076 0.208022 0.344758C0.0693408 0.483439 0 0.646885 0 0.835096C0 1.02331 0.0693408 1.18675 0.208022 1.32543L6.15152 7.26893Z" fill="currentColor"/></svg>';

  function norm(v) {
    return (v === null || v === undefined ? '' : String(v)).trim().toLowerCase();
  }

  function escapeHtml(s) {
    return String(s === null || s === undefined ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function escapeAttr(s) {
    return escapeHtml(s).replace(/"/g, '&quot;');
  }

  function Block(root) {
    this.root = root;
    this.accEl = root.querySelector('[data-hertz-documents-accordion]');
    this.emptyEl = root.querySelector('[data-hertz-documents-empty]');

    var tpl = root.querySelector('[data-hertz-documents-icon]');
    this.icon = tpl ? tpl.innerHTML : '';

    // Categories the shopper has expanded, preserved across variant changes.
    this.open = {};
    this.touched = false;

    try {
      this.docs = JSON.parse(root.querySelector('[data-hertz-documents-json]').textContent) || [];
    } catch (err) {
      this.docs = [];
    }

    this.render();
    this.bind();
  }

  /* Current parameter values, keyed by lowercased parameter name. */
  Block.prototype.selection = function () {
    var out = {};
    var selects = document.querySelectorAll('product-constructor select[data-parameter]');
    Array.prototype.forEach.call(selects, function (sel) {
      out[norm(sel.getAttribute('data-parameter'))] = norm(sel.value);
    });
    return out;
  };

  /* A document matches when, for every restricted dimension, one of its allowed
     values appears in the currently selected value. Empty list = no restriction. */
  Block.prototype.matches = function (doc, current) {
    for (var i = 0; i < PARAMS.length; i++) {
      var key = PARAMS[i];
      var rules = doc.match && doc.match[key];
      if (!rules || !rules.length) continue;

      var value = current[key];
      if (value === undefined) continue;

      var hit = false;
      for (var j = 0; j < rules.length; j++) {
        if (value.indexOf(norm(rules[j])) !== -1) { hit = true; break; }
      }
      if (!hit) return false;
    }
    return true;
  };

  Block.prototype.render = function () {
    var self = this;
    var current = this.selection();

    var matched = this.docs.filter(function (d) { return self.matches(d, current); });

    var groups = {};
    matched.forEach(function (d) {
      var name = d.category || 'Documents';
      if (!groups[name]) {
        groups[name] = { name: name, order: d.categoryOrder == null ? 999 : d.categoryOrder, docs: [] };
      }
      groups[name].docs.push(d);
    });

    var cats = Object.keys(groups).map(function (k) { return groups[k]; });
    cats.sort(function (a, b) { return (a.order - b.order) || a.name.localeCompare(b.name); });
    cats.forEach(function (c) {
      c.docs.sort(function (a, b) {
        var ao = a.order == null ? 999 : a.order;
        var bo = b.order == null ? 999 : b.order;
        return (ao - bo) || String(a.title).localeCompare(String(b.title));
      });
    });

    if (!cats.length) {
      this.accEl.innerHTML = '';
      this.emptyEl.hidden = false;
      return;
    }
    this.emptyEl.hidden = true;

    // Until the shopper opens something themselves, default to the first category.
    var anyOpen = cats.some(function (c) { return self.open[c.name]; });
    if (!anyOpen && !this.touched) this.open[cats[0].name] = true;

    this.accEl.innerHTML = cats.map(function (c) {
      var items = c.docs.map(function (d) {
        return '<li class="hertz-docs__item"><a href="' + escapeAttr(d.url) +
          '" target="_blank" rel="noopener">' + self.icon +
          '<span>' + escapeHtml(d.title) + '</span>' +
          (d.revision ? '<span class="hertz-docs__rev">' + escapeHtml(d.revision) + '</span>' : '') +
          '</a></li>';
      }).join('');

      return '<details class="hertz-docs__cat" data-hertz-category="' + escapeAttr(c.name) + '"' +
        (self.open[c.name] ? ' open' : '') + '>' +
        '<summary class="hertz-docs__cat-head"><span>' + escapeHtml(c.name) + '</span>' +
        '<span class="hertz-docs__cat-count">' + c.docs.length + '</span>' + CARET + '</summary>' +
        '<ul class="hertz-docs__list">' + items + '</ul></details>';
    }).join('');
  };

  Block.prototype.bind = function () {
    var self = this;

    // `toggle` does not bubble, so listen during the capture phase.
    this.accEl.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d || !d.hasAttribute || !d.hasAttribute('data-hertz-category')) return;
      self.touched = true;
      self.open[d.getAttribute('data-hertz-category')] = d.open;
    }, true);

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('product-constructor select[data-parameter]')) {
        self.render();
      }
    });

    document.addEventListener('variant:change', function () { self.render(); });
  };

  function init() {
    var blocks = document.querySelectorAll('[data-hertz-documents]');
    Array.prototype.forEach.call(blocks, function (el) {
      if (!el.hertzDocsBlock) el.hertzDocsBlock = new Block(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
